import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import CpapWrapper from "@components/layouts/cpapWrapper";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";

export default function CarInjuryJusticeHome(): ReactElement {
    return (
        <CpapWrapper>
            <div className="w-full max-w-7xl mx-auto">
                <PrivacyPolicy category="CPAP" domain="Cpap.Claims" />
            </div>
        </CpapWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
